/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'pip-model',
    'pip-events',
    'window'
],
function(
    $,
    pip,
    pipEvents,
    window
){

  function initEventListeners() {
  pipEvents.instantCheckout.instantCheckoutAnalytics.off();
  pipEvents.instantCheckout.instantCheckoutAnalytics.on(function(){
    if (window.digitalData && window.digitalData.content) {
          $.extend(window.digitalData.content , {
                feature: { instantCheckoutDisplayed: "y" }
          });
        }
    });
  }

return {
  init: function init() {
    initEventListeners();
  }
}

});

}.call(window));